import './home.css'

import { Input, Space, Button } from 'antd'
const ContactView = () => {
    
    return (
        <div className='contact-container'>
            <div className='contact-left'>
                <h1>GET IN TOUCH</h1>
                <span>500 Terry Francois Street, 6th Floor. San Francisco, CA 94158</span>
            </div>
            <div className='contact-right'>

                <Space.Compact style={{ margin: 10 }}>
                    <Space.Addon style={{ width: 100 }}>*Name</Space.Addon>
                    <Input style={{ width: 400 }} placeholder='Enter your name' />
                </Space.Compact>

                <Space.Compact style={{ margin: 10 }}>
                    <Space.Addon style={{ width: 100 }}>*Email</Space.Addon>
                    <Input style={{ width: 400 }} placeholder='Enter your email' />
                </Space.Compact>
                <Space.Compact style={{ margin: 10 }}>
                    <Space.Addon style={{ width: 100 }}>Phone</Space.Addon>
                    <Input style={{ width: 400 }} placeholder='Enter your phone number' />
                </Space.Compact>
                <Space.Compact style={{ margin: 10 }}>
                    <Space.Addon style={{ width: 100 }}>Address</Space.Addon>
                    <Input style={{ width: 400 }} placeholder='Enter your address' />
                </Space.Compact>
                <Space.Compact style={{ margin: 10 }}>
                    <Space.Addon style={{ width: 100 }}>Message</Space.Addon>
                    <Input.TextArea style={{ width: 400 }} placeholder='Enter your message here...' />
                </Space.Compact>
                <Space.Compact style={{ margin: 10, width:500}}>

                <Button block>
                    Submit
                </Button>

                </Space.Compact>
            </div>
        </div>
    )
}

export default ContactView